import React, {useMemo} from 'react';
import {Popup} from 'semantic-ui-react';
import PropTypes from 'prop-types';

import PopupTable from '@appComponents/PopupTable';
import {generateTunnelRows, getTunnelStatusIcon} from '@modules/thirdPartyClientTunnel/utils/helpers';

const ThirdPartyClientTunnelStatus = ({thirdPartyClientTunnels = []}) => {
    const tunnelsContent = useMemo(() => (
        thirdPartyClientTunnels.map((tunnel) => {
            return (
                <Popup
                    className='--noPadding'
                    key={`tunnel_id-${tunnel.id}`}
                    trigger={getTunnelStatusIcon(tunnel.is_placeholder_for_auto_assignment, tunnel.vtd_tunneler?.started)}
                    flowing
                    hoverable
                >
                    <PopupTable rows={generateTunnelRows(tunnel)}/>
                </Popup>
            );
        })
    ), [thirdPartyClientTunnels]);

    return <>{tunnelsContent}</>;
};

ThirdPartyClientTunnelStatus.propTypes = {
    thirdPartyClientTunnels: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            client: PropTypes.shape({
                id: PropTypes.number,
                name: PropTypes.string,
            }),
            is_placeholder_for_auto_assignment: PropTypes.bool,
            vtd_tunnel_id: PropTypes.number,
            vtd_tunneler: PropTypes.shape({
                id: PropTypes.number,
                name: PropTypes.string,
                started: PropTypes.bool,
            }),
        })
    ).isRequired,
};

export default ThirdPartyClientTunnelStatus;
